import { gql } from '@apollo/client';

export default gql`
  query spacePermissions(
    $page: Int
    $firstname: String
    $surname: String
    $search: String
    $email: String
    $sortBy: String
  ) {
    space {
      adminRole
    }
    spacePermissions(
      page: $page
      email: $email
      name: $firstname
      surname: $surname
      search: $search
      sortBy: $sortBy
    ) {
      hasNextPage
      permissionsTotalPages
      permissionsTotal
      currentPage
      permissions {
        id
        role
        confirmed
        user {
          id
          email
          name
          surname
        }
      }
    }
  }
`;
